<div class="text-center">
  <div
    class="spinner-border spinner-border-sm color-qaroni-primary80"
    role="status">
    <span class="visually-hidden">cargando...</span>
  </div>
</div>
